import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@/utils/cn';

type AppModalProps = PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  footer?: ReactNode;
  size?: 'compact' | 'default' | 'wide';
}>;

export function AppModal({
  open,
  onOpenChange,
  title,
  description,
  footer,
  size = 'default',
  children,
}: AppModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal-overlay" />
        <Dialog.Content className={cn('modal-card', `modal-card--${size}`)}>
          <header className="modal-card__header">
            <div>
              <Dialog.Title className="modal-card__title">{title}</Dialog.Title>
              {description ? (
                <Dialog.Description className="modal-card__description">
                  {description}
                </Dialog.Description>
              ) : null}
            </div>
            <Dialog.Close asChild>
              <button type="button" className="icon-button" aria-label="Close dialog">
                <X size={18} />
              </button>
            </Dialog.Close>
          </header>
          <div className="modal-card__body">{children}</div>
          {footer ? <footer className="modal-card__footer">{footer}</footer> : null}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
